import styled from "styled-components";

export const StyledProgressBarPercent = styled.div`
	position: absolute;
	display: inline-block;
	font-size: 0.8rem;
	color: ${({ theme: { colors } }) => colors.whiteAlways};
	left: ${({ position }) => `calc(${position}% - 15px)`};
	top: 2px;
	cursor: default;
`;
